import dbg from "debug";

const debug = dbg("jp:api:client");

const errorLog = (handler) => (error) => {
  const { config, response } = error;

  if (handler) {
    try {
      handler(error);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    }
  }

  debug("request:failed", config?.url, response?.headers, response?.data);
  return Promise.reject(error);
};

export default errorLog;
